invHdApp.controller('TicketController', ['$scope', 'Ticket', '$location', '$routeParams', '$filter', '$translate', 'FileUploader',
  function ($scope, Ticket, $location, $routeParams, $filter, $translate, FileUploader) {
    $scope.deleted = [];
    $scope.filterData = {
      customers: [],
      workers: [],
      workSteps: [],
      page: 1,
      created_at: {
        startDate: null,
        endDate: null
      },
      scheduled_time: {
        startDate: null,
        endDate: null
      }
    }

    setTimeout(() => {
      if ($routeParams.order_id && $routeParams.order_id != 'false') {
        $('#ticketModal').modal('show');
        $scope.new();
      }
    }, 400);

    $scope.attachedFile = null;

    $scope.handleFileUpload = function (files) {
      if (files && files.length) {
        $scope.attachedFile = files[0];
        $scope.$apply();
      }
    };

    // Controller'a geri dönüş fonksiyonu ekleme
    $scope.goBack = function () {
      if ($scope.ticket.step > 1) {
        $scope.ticket.step--;
      }
    };

    $scope.subcategories = {
      order: [
        'Sipariş Dağıtıma Çıkmadı',
        'Hasarlı Teslimat',
        'Siparişim Nerede',
        'Ürünü Teslim Etmeyin',
        'Ürün Tesliminde İade Ürün Alınacak',
        'Alıcıya Ulaşılamıyor',
        'Alıcı Adreste Yok',
        'Eksik Hatalı Telefon Numarası',
        'Müşteri İptal Etti',
        'Diğer'
      ],
      technical: [
        'Zimmet Alamıyorum',
        'Otomatik Rotalama Yapamıyorum',
        'Fotoğraf Yükleme Yapamıyorum',
        'İşin Statüsünü Değiştiremiyorum',
        'Not Ekleyemiyorum',
        'İşleri Sisteme Yükleyemiyorum',
        'Entegrasyon Problemi',
        'Diğer'
      ],
      other: [
        'Diğer Konular'
      ]
    };

    $scope.getCategoryName = function (categoryValue) {
      var category = $scope.filterTicketCategory.find(function (item) {
        return item.value === categoryValue;
      });
      return category ? category.name : 'Bilinmeyen Kategori';
    };

    $scope.selectCategory = function (category) {
      $scope.ticket.category = category;
      $scope.currentSubcategories = $scope.subcategories[category];
      $scope.ticket.step = 2;
    };

    $scope.selectSubcategory = function (subcategory) {
      $scope.ticket.sub_category = subcategory;
      $scope.ticket.step = 3;
    };

    $scope.submitForm = function () {
      if ($scope.problemForm.$valid) {
        $scope.ticket.step = 4;
      }
    };

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.filter();
    }

    $scope.sort = function (field, sort) {
      $scope.filterData.field = field;
      $scope.filterData.sort = sort;
      $scope.filter();
    }

    $scope.filter = function (type) {
      if (type == 'clear') {
        $scope.filterData = {
          customers: [],
          companies: [],
          page: 1,
        }
        $scope.filterProp = [];
      } else {
        $scope.filterData.filterProp = $scope.filterProp;
        if (typeof $scope.filterData.created_at.endDate !== 'undefined' && $scope.filterData.created_at.endDate !== null) {
          $scope.filterData.filterProp.created_at = 'created_at';
        }
        if (typeof $scope.filterData.scheduled_time.endDate !== 'undefined' && $scope.filterData.scheduled_time.endDate !== null) {
          $scope.filterData.filterProp.scheduled_time = 'scheduled_time';
        }
      }
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing tickets...')
      $scope.all();
    }, true);

    $scope.all = function () {
      Ticket.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;
        if (typeof $scope.filterData.filterProp !== 'undefined') {
          $scope.filterProp = [];
          if (angular.isArray($scope.filterData.filterProp)) {
            for (var i = $scope.filterData.filterProp.length - 1; i >= 0; i--) {
              $scope.filterProp.push($scope.filterData.filterProp[i])
            }
          } else {
            $scope.filterProp.push($scope.filterData.filterProp);
          }
        }
      });
    }

    $scope.openDetail = function (item) {
      $scope.ticketConversation = {
        ticket_id: item.id
      }
      Ticket.get(item.id).success(function (data, status, headers, config) {
        $('#ticketModal').modal('show');
        $scope.ticket = data.ticket;
        $scope.ticket.conversations.forEach(element => {
          element.type = element.user_id != $scope.authenticatedUser.user_id ? 'sender' : 'receiver';
        });
      });
    }

    $scope.$on('new_data', function () {
      $('#ticketModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Ticket.new().success(function (data, status, headers, config) {
        $scope.ticket = {
          content: '',
          subcat: '',
          sub_category: '',
          step: 1
        };
        if ($routeParams.order_id && $routeParams.order_id != 'false') {
          $scope.ticket.order_id = $routeParams.order_id;
        }
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Ticket.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate(data.message.toString()));
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.tickets.indexOf($filter('filter')($scope.data.tickets, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.tickets.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.ticket.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      Ticket.save($scope.ticket).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#ticketModal').modal('hide');
        $scope.openDetail(data.data)
        $scope.all();
        if ($scope.ticket.order_id && $routeParams.order_id != 'false') {
          // $location.path('/live-chat').search('order_id', false);
        }
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.addConversation = function () {
      Ticket.addConversation($scope.ticketConversation).success(function (data, status, headers, config) {
        Messenger().post('Başarılı');
        $scope.openDetail($scope.ticket)
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.closeTicket = function () {
      if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
        Ticket.closeTicket($scope.ticket).success(function (data, status, headers, config) {
          Messenger().post('Başarılıyla kapandı');
          $scope.openDetail($scope.ticket)
          $scope.all();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.update = function () {
      Ticket.update($scope.ticket).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#ticketModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    var logo = $scope.logo = new FileUploader({
      url: '/api/upload-file',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      autoUpload: true
    });

    logo.filters.push({
      name: 'formatFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
      }
    });

    logo.onAfterAddingFile = function (fileItem) {
      $scope.proccessProfile = true;
      $scope.pending = true;
    };

    logo.onCompleteItem = function (item, response, status, headers) {
      $scope.proccessProfile = false;
      $scope.ticket.file = response.file;
      if (response.status == 'success')
        $scope.pending = false;
    }

  }
]);